import { Stack, alpha, useTheme } from "@mui/material";
import React from "react";

const CommunicationWaysItemsWrapper = ({ children }) => {
  const theme = useTheme();
  return (
    <>
      <Stack
        alignItems="center"
        justifyContent="start"
        p={1}
        // bgcolor={alpha(theme.palette.primary.light, 0.08)}
        direction="row"
        spacing={1}
        fullWidth
        sx={{
          borderRadius: 2,
        }}
      >
        {children}
      </Stack>
    </>
  );
};

export default CommunicationWaysItemsWrapper;
